import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "What is Projectional Editing?",
description: "Explains the concept of projectional editing, how Freon maps the AST directly to a visual projection, and how it handles expressions, rebalancing, and persistence in projectional workflows.",
tags: [ "Freon", "projectional editing", "AST", "expressions", "tree balancing", "persistence", "model editing", "workflow", "structure editor", "documentation"] ,
modifiedTime: "2025-11-07T17:20:18.649Z",
publishedTime: "2025-11-07T17:20:18.647Z"
    }
  };
};